export function isSimilar(login, password) {
    login = login || '';
    password = password || '';
    const loginL = login.trim().toLowerCase();
    const passwordL = password.trim().toLowerCase();

    if (loginL.indexOf(passwordL) !== -1) {
        return true;
    }
    if (passwordL.indexOf(loginL) !== -1) {
        return true;
    }
    if (loginL.substring(0, 8) === passwordL.substring(0, 8)) {
        return true;
    }
    return false;
}
